import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-65d048ef"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "inner-container"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", {
    class: "title"
  }, "青少年人工智能编程水平测试（YCL）", -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title-desc"
  }, " YCL等级考试为广大青少年的实习、进修等提供在人工智能编程方面能力水平的证明 ", -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "sub-title-1"
  }, "YCL等级考试", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "sub-title-english-1"
  }, " THE YOUTH ARTIFICIAL INTELLIGENCE CODING LEVEL TEST ", -1);
});

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "sub-title-desc-1"
  }, [/*#__PURE__*/_createElementVNode("div", null, " 青少年人工智能编程水平测试主要用于考查应试人员在程序思维、编程语言、数据处理及人工智能算法方面的能力水平，水平测试体系分为1-8级，难度逐级提升。 "), /*#__PURE__*/_createElementVNode("div", null, " 证书由工业和信息化部教育与考试中心，中国电子教育学会联合盖章颁发。编程水平测试题库由中国科学院计算技术研究所开发设计。 ")], -1);
});

var _hoisted_8 = {
  class: "image-container"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "sub-title-2"
  }, "近期核桃编程专场考试安排", -1);
});

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "sub-title-desc-2"
  }, "1月8日，2月19日、20日，4月", -1);
});

var _hoisted_11 = [_hoisted_9, _hoisted_10];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_col = _resolveComponent("a-col");

  var _component_a_row = _resolveComponent("a-row");

  var _component_ImageAccordion = _resolveComponent("ImageAccordion");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        span: 24
      }, {
        default: _withCtx(function () {
          return [_hoisted_3, _hoisted_4];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_a_row, {
    gutter: 45
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_hoisted_5, _hoisted_6, _hoisted_7, _createElementVNode("div", null, [_createElementVNode("span", {
            class: "btn-more",
            onClick: _cache[0] || (_cache[0] = //@ts-ignore
            function () {
              return _ctx.checkMore && _ctx.checkMore.apply(_ctx, arguments);
            })
          }, "查看更多")])];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        span: 16
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_8, [_createVNode(_component_ImageAccordion, {
            list: _ctx.imageList
          }, null, 8, ["list"])]), _createElementVNode("div", {
            class: "qceit-info-box",
            onClick: _cache[1] || (_cache[1] = //@ts-ignore
            function () {
              return _ctx.checkDetail && _ctx.checkDetail.apply(_ctx, arguments);
            })
          }, _hoisted_11)];
        }),
        _: 1
      })];
    }),
    _: 1
  })])]);
}